<template>
  <b-sidebar
    id="sidebar-create-period"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ period.id ? $t('Update Period') : 'Create Period' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <b-form-group
          :label="$t('period.Name')"
          label-for="name"
        >
          <b-form-input
            id="name"
            v-model="period.name"
            trim
          />
        </b-form-group>

        <b-form-group
          :label="$t('period.Info')"
          label-for="info"
        >
          <b-form-input
            id="info"
            v-model="period.info"
            trim
          />
        </b-form-group>

        <b-form-group
          :label="$t('period.Admission Year')"
          label-for="admission-year"
        >
          <b-form-input
            id="admission-year"
            v-model="period.admission_year"
            trim
          />
        </b-form-group>

        <b-form-group
          :label="$t('period.Is Active')"
          label-for="is_active"
        >
          <v-select
            id="is_active"
            v-model="period.is_active"
            :reduce="(option) => option.value"
            :options="options"
            label="text"
          />
        </b-form-group>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ period.id ? $t('Update Period') : $t('Create Period') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    options: {
      get() {
        return [
          { value: true, text: this.$t('Active') },
          { value: false, text: this.$t('Not Active') },
        ]
      },
    },
    period: {
      get() {
        return this.$store.state.period.period
      },
      set(data) {
        this.$store.commit('period/UPDATE', data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('period/FRESH')
      hide()
    },
    submit(hide) {
      const period = { ...this.period }
      for (let i = 1; i <= this.stepsCountInPeriod; i += 1) {
        const step = period[`step_${i}`]
        if (step) period[`step_${i}`] = step.is_active
      }
      this.$createSwal(this, period, `period/${this.period.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit('period/FRESH')
      })
      hide()
    },
  },
  setup() {
    const { stepsCountInPeriod } = store.state.staticModule
    return {
      stepsCountInPeriod,
    }
  },
}
</script>
